import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Paso4pagePage } from './paso4page.page';

const routes: Routes = [
  {
    path: '',
    component: Paso4pagePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Paso4pagePageRoutingModule {}
